import React, { useEffect, useState } from 'react';
import { Dots } from './Dots';
import { useNavigate } from "react-router-dom";
import { Badge, Button, Select, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { ApiGetAllPedidosByFecha } from '../../api/tickets';
import { ApiGetAllComidas } from '../../api/comidas';
var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
//DD-MM-YYYY

const Recepcion = () => {
  const navigate = useNavigate();

  const [pedidos, setPedidos] = useState([]);
  const [pedidosFiltered, setPedidosFiltered] = useState([]);
  const [comidas, setComidas] = useState([]);
  const [comidaSelected, setComidaSelected] = useState("all");
  const [comidasMenu, setComidasMenu] = useState([]);

  const [menu, setMenu] = useState("");

  useEffect(() => {
    getPedidos();

    // Set up the interval
    const intervalId = setInterval(() => {
      getPedidos();
    }, 5000); // Refresh every 5 seconds

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    getComidasMenu();
  }, []);

  useEffect(() => {
    let filtered = pedidos;

    if (comidaSelected !== 'all') {
      filtered = filtered.filter(pedido =>
        pedido.comida === comidaSelected
      );
    }

    setPedidosFiltered(filtered);
  }, [comidaSelected, pedidos]);

  useEffect(() => {
    let menu = "";

    if (comidaSelected === 'all') {
      // Formar el menú de todas las comidas
      comidasMenu.forEach(comida => {
        menu += `${comida.nombre}\n${comida.menu}\n\n`;
      });
    } else {
      // Formar el menú de la comida seleccionada
      const selectedMenu = comidasMenu.find(comida => comida.nombre === comidaSelected);
      if (selectedMenu) {
        menu = `${selectedMenu.nombre}\n${selectedMenu.menu}\n\n`;
      }
    }

    setMenu(menu);
  }, [comidaSelected, comidasMenu]);


  const getComidasMenu = async () => {
    const res = await ApiGetAllComidas();
    if (res.sms === "ok") {
      setComidasMenu(res.data);
    }
  };

  const getPedidos = async () => {
    const fecha = dayjs().format("DD-MM-YYYY");
    let res = await ApiGetAllPedidosByFecha(fecha);
    if (res.sms === "ok") {

      const respedidos = res.pedidos.filter(pedido => pedido.client_estado === "CONFIRMADO");

      let comidas = respedidos.map(pedido => pedido.comida);
      comidas = [...new Set(comidas)]; // Obtener comidas unicas

      setComidas(comidas);
      setPedidosFiltered(respedidos);
      setPedidos(respedidos);
    }
  };


  return (
    <div
      style={{
        padding: "20px 25px",
      }}
    >
      <Dots
        style={{ left: 0, top: 0, position: "absolute", color: "#c6cfdd" }}
      />
      <Dots
        style={{ left: 60, top: 0, position: "absolute", color: "#c6cfdd" }}
      />
      <Dots
        style={{ left: 0, top: 140, position: "absolute", color: "#c6cfdd" }}
      />
      <Dots
        style={{ right: 0, top: 60, position: "absolute", color: "#c6cfdd" }}
      />
      <div className="position-relative z-index-1" >
        <div className="bg-white shadow px-5 py-3 rounded" >
          <div className="d-flex justify-content-between align-items-center mt-1">
            <Text size="xl" fw="bold" >
              Pedidos de hoy
            </Text>
            <div>
              <Button
                leftIcon={<i className="fas fa-arrow-left"></i>}
                variant='outline' mx={4}
                onClick={() => navigate("/")}
              >
                Volver
              </Button>
              <Button variant='outline' color='red'
                leftIcon={<i className="fas fa-sign-out-alt"></i>}
                onClick={() => {
                  localStorage.removeItem("datauser");
                  localStorage.removeItem("accessTokenAdm");
                  localStorage.setItem("panel", false);
                  window.location = "/";
                }}
              >
                Salir
              </Button>
            </div>
          </div>

        </div>
        <div className="bg-white shadow px-5 pb-5 rounded mt-3 d-flex flex-column"
          style={{
            minHeight: "460px",
          }}
        >
          <div className="d-flex justify-content-center flex-grow-1">
            <div className='w-100 d-flex flex-column mx-2' >
              <div className='d-flex justify-content-center mt-2'>
                <Select
                  label="Comida"
                  data={[
                    { value: 'all', label: 'Todas' },
                    ...comidas.map(comida => ({ value: comida, label: formatLabel(comida) }))
                  ]}
                  placeholder="Selecciona una opción"
                  size="sm"
                  defaultValue="all"
                  onChange={(value) => setComidaSelected(value)}
                />
              </div>
              <div className="flex-grow-1 d-flex align-items-stretch">
                <div className="w-100 mt-3 overflow-auto rounded scrollable-div"
                  style={{
                    maxHeight: "350px",
                    border: "1px solid #c6cfdd"
                  }}
                >
                  {pedidosFiltered.map((pedido, index) => (
                    <div key={index} className="d-flex justify-content-between align-items-center border py-2 px-2 rounded shadow-sm m-2">
                      <div className="d-flex align-items-center gap-2">
                        <span className="px-3 mx-1"
                          style={{
                            backgroundColor: "#f1f1f1",
                            borderRadius: "5px",
                            fontSize: "1.5rem",
                          }}
                        >
                          {pedido.consecutivo_periodo_fecha}
                        </span>
                        <div className="d-flex flex-column align-items-start gap-1">
                          <span className="fw-bold"
                            style={{
                              fontSize: "1.5rem",
                            }}
                          >
                            {pedido.pre_usuarios.nombres} {pedido.pre_usuarios.apellidos}
                          </span>
                          <span>
                            {pedido.comida}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/*contador de pedidos*/}
            <div className="d-flex flex-column justify-content-center mx-2">
              <p className="text"
                style={{
                  fontSize: "1rem",
                  marginBottom: "0px",
                }}
              >Numero de {comidaSelected === 'all' ? 'pedidos' : formatLabel(comidaSelected) + "(s)"}</p>
              <div className="d-flex justify-content-center align-items-center shadow rounded"
                style={{
                  width: "200px",
                  height: "200px",
                  backgroundColor: "#1b3765",
                  color: "#fff",
                }}
              >
                <p
                  style={{
                    fontSize: "5rem",
                    fontWeight: "bold",
                  }}
                >
                  {pedidosFiltered.length}
                </p>
              </div>
              <div>
                {/*Mostrar el menu de las comidas o la comida seleccionada */}
                <div className="d-flex flex-column justify-content-center align-items-center mt-3">
                  <Text size="xl" fw="bold" >
                    Menu
                  </Text>

                  <textarea
                    value={menu}
                    rows={10}
                    cols={32}
                    className="w-100 mt-2"
                    readOnly
                    style={{
                      border: "1px solid #c6cfdd",
                      borderRadius: "5px",
                      padding: "5px",
                      fontSize: "1.2rem",
                      overflow: "hidden",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function formatLabel(label) {
  return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
}

export default Recepcion